(function () {
function initHomeCards(tabsRoot) {
    const cards = Array.from(tabsRoot.querySelectorAll('[data-home-cards-card]'));
    if (!cards.length) return;

    const stackedMq = window.matchMedia('(max-width: 768px)');

    const resetActive = () => {
        cards.forEach((card) => card.classList.remove('is-active'));
    };

    const setActive = (index) => {
        if (index < 0 || index >= cards.length) return;

        cards.forEach((card, cardIndex) => {
            card.classList.toggle('is-active', cardIndex === index);
        });
    };

    cards.forEach((card, index) => {
        card.addEventListener('mouseenter', () => {
            if (stackedMq.matches) return;
            setActive(index);
        });

        card.addEventListener('focusin', () => {
            if (stackedMq.matches) return;
            setActive(index);
        });

        card.addEventListener('click', (event) => {
            if (stackedMq.matches) return;

            if (!card.classList.contains('is-active')) {
                event.preventDefault();
                setActive(index);
            }
        });
    });

    tabsRoot.addEventListener('mouseleave', () => {
        if (stackedMq.matches) return;
        resetActive();
    });

    stackedMq.addEventListener('change', () => {
        if (stackedMq.matches) {
            resetActive();
        }
    });

    resetActive();
}

document.querySelectorAll('[data-home-cards]').forEach(initHomeCards);

})();
